import { createContext, useState } from "react";

const AppContext = createContext({
  selectedKota: null,
  setSelectedKota: function (kota) {},
  listKota: [],
  setListKota: function (listKota) {},
});

const AppContextProvider = (props) => {
  const [kota, setKota] = useState(null);
  const [listKota, setListKota] = useState([]);

  const setSelectedKota = (kota) => {
    setKota(kota);
  };

  const context = {
    selectedKota: kota,
    setSelectedKota: setSelectedKota,
    listKota: listKota,
    setListKota: setListKota,
  };

  return (
    <AppContext.Provider value={context}>{props.children}</AppContext.Provider>
  );
};

export { AppContextProvider };

export default AppContext;
